import type { ISceneObj } from 'src/types/SceneType';

export const collectSceneFids = (scene: ISceneObj | undefined): Set<string> => {
	const ids = new Set<string>();
	const walk = (v: unknown): void => {
		if (!v || typeof v !== 'object') return;
		if (Array.isArray(v)) {
			v.forEach(walk);
			return;
		}
		const o = v as Record<string, unknown>;
		if (typeof o._fid === 'string' && o._fid.length > 0) ids.add(o._fid);
		Object.values(o).forEach(walk);
	};
	walk(scene?.if);
	walk(scene?.do);
	walk(scene?.else);
	return ids;
};
